<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 10" :class="[`${prefix}-icon`, `${prefix}-icon-fire2`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_81c1510644__a"><rect width="10" height="10" rx="0"/></clipPath></defs><g clip-path="url(#svg_81c1510644__a)"><path d="M8.1788330078125,5.7415771484375C8.1788330078125,5.3115771484375,7.9450830078125,4.3628271484375,7.4363330078125,3.4040771484375C7.4275830078125,3.7253271484375,7.1675830078125,4.5015771484375,6.9763330078125,4.709077148437499C6.8488330078125,4.3465771484375,6.8163330078125,1.9303271484375,3.6288330078125,1.1165771484375C3.8225830078125,3.5203271484375,1.4288330078125,3.4853271484375,1.4288330078125,6.0790771484375C1.4288330078125,7.5140771484375,2.3225830078125,8.739077148437499,3.5838330078125,9.2290771484375C3.1813330078125,7.9715771484375,3.8100830078125,6.6928271484375,4.9725830078125,5.5328271484375C5.177583007812499,7.0703271484375,6.2788330078125,7.4978271484375,6.2650830078125,9.1215771484375C7.4838330078125,8.5228271484375,8.2813330078125,7.1965771484375,8.1788330078125,5.7415771484375Z" :fill="useCurrentColor ? 'currentColor' : '#BEBEBE'"/></g></svg>
</template>
<script>

export default {
  name: 'IconFire2',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
